import React from 'react';
import { Field, useForm, useFormState } from 'react-final-form';

import {
  REQUIRED,
  GREATER_THAN_OR_EQUAL_TO_ZERO,
  MAX_GUEST_COUNT,
} from '../../../../Form/util/validations';
import { useEffectOnce } from '../../../../../hooks';

import OnboardStep, { OnboardStepProps } from '../../../OnboardStep';
import FormInput from '../../../../Form/inputV3/FinalFormInput';
import GuestCount from '../../panes/GuestCount';

import { StyledFormCheckbox } from './GuestCountStep.styles';

type GuestCountStepProps = Pick<OnboardStepProps, 'portalContent' | 'hed' | 'dek'> & {
  className?: string;
};

const GuestCountStep = ({
  hed = "Sounds like a party! Who's making the list?",
  dek = "Team-Z tip: use Contact Collector to get everyone's addresses in one easy go!",
  portalContent = <GuestCount />,
  className,
}: GuestCountStepProps): JSX.Element => {
  const { change, blur } = useForm();
  const { values } = useFormState();

  const MAYBE_REQUIRED = (
    value?: string | number,
    allValues?: Partial<{ skip_guest_count?: boolean }>
  ) => (allValues?.skip_guest_count ? undefined : REQUIRED(value));

  useEffectOnce(() => {
    // Validation is not working for fields not in the dom when the form is initialized.
    // blur() of one field triggers validation for the rest of the fields on page
    // TODO: Find a sustainable solution/fix for validating new form fields in react-final-form
    blur('skip_guest_count');
  });

  return (
    <OnboardStep
      hed={hed}
      dek={dek}
      portalContent={portalContent}
      nextButtonText="Next"
      className={className}
    >
      <FormInput
        name="guest_count"
        id="guest_count"
        label="Enter your guest count (best guesses welcome!)"
        type="number"
        min="0"
        onFocus={() => change('skip_guest_count', undefined)}
        validate={[MAYBE_REQUIRED, GREATER_THAN_OR_EQUAL_TO_ZERO, MAX_GUEST_COUNT]}
      />
      <Field
        name="skip_guest_count"
        label="We're still deciding"
        component={StyledFormCheckbox}
        id="checkbox-skip_guest_count"
        type="checkbox"
        onClick={() => {
          if (values.guest_count) change('guest_count', undefined);
        }}
      />
    </OnboardStep>
  );
};

export default GuestCountStep;
